import { useEffect, useState } from "react";
import { api, asArray } from "@/lib/api";
import { TrendingUp } from "lucide-react";

export default function Opportunities() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/opportunities").then(r => setItems(asArray(r.data))); }, []);
  const total = items.reduce((a, c) => a + (c.estimated_value_usd || 0), 0);
  return (
    <div className="space-y-4">
      <div>
        <div className="text-[10px] uppercase tracking-[0.18em] text-zinc-500 font-mono">MSP Sales Enablement</div>
        <h1 className="font-display text-3xl font-semibold tracking-tight mt-1">Opportunities ({items.length})</h1>
        <div className="text-emerald-400 font-mono text-sm mt-1">Pipeline value · ${total.toLocaleString()}</div>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        {items.map(o => (
          <div key={o.id} className="bg-zinc-950 border border-zinc-900 rounded-md p-5" data-testid={`opp-card-${o.id}`}>
            <div className="flex items-center gap-2 mb-2"><TrendingUp size={14} className="text-emerald-400"/><div className="text-[10px] uppercase tracking-widest text-zinc-500 font-mono">{o.kind.replaceAll("_"," ")}</div></div>
            <h2 className="font-display text-lg">{o.name}</h2>
            <div className="text-xs text-zinc-500 mt-1">For <span className="text-zinc-300">{o.client_name}</span></div>
            <div className="flex items-center justify-between mt-3">
              <div className="text-emerald-400 font-mono text-xl">${o.estimated_value_usd.toLocaleString()}</div>
              <div className="text-xs font-mono text-zinc-400">Confidence {o.confidence_pct}%</div>
            </div>
          </div>
        ))}
        {items.length === 0 && <div className="text-zinc-500 text-sm">No actionable opportunities yet — opportunities surface when clients accumulate security/compliance/recurring debt.</div>}
      </div>
    </div>
  );
}
